'use strict';

const { h } = require('phy');
const { Translate } = require('@grpn/preact-l10n');
const { pruneData } = require('../../support/prune-data');
const EmailSubscriptionForm = require('./email-subscription-form-hoc');

function getGreetingText(merchantName) {
  return merchantName
    ? 'js.modules.email_subscription.MerchantAlert'
    : 'js.modules.email_subscription.Alert';
}

function EmailSubscription({
  csrfToken,
  routes,
  classNames: {
    outer = 'email-subscription-outer',
    inner = 'email-subscription-inner',
  } = {},
  bhwName,
  merchantName,
}) {
  return h('', { 'data-bhw': bhwName, class: outer }, [
    h(`.email-subscription.${inner}`, [
      h('.container-top', [
        h('.icon-bell'),
        h(
          Translate,
          {
            attrs: { class: 'email-greeting' },
            0: h('.email-subscription-merchant-name', merchantName),
          },
          getGreetingText(merchantName)
        ),
      ]),
      EmailSubscriptionForm({
        csrfToken,
        routes: pruneData(
          routes,
          'email_subscription:main',
          'terms',
          'privacy'
        ),
      }),
    ]),
  ]);
}

module.exports = EmailSubscription;
